import axios from 'axios'
import EventBus from "@/commons/EventBus";
import JWTBusiness from "@/business/JWTBusiness";

const server = process.env.VUE_APP_SERVER;
export {server}

const authError = (error) => {
  toggleLoading('post', false);
  if(error.response && error.response.status == 401){
    EventBus.logout();
  }
  if(error && error.response){
    error = error.response;
    if(error.data){
      error = error.data;
    }
  }
  return Promise.reject(error);
};

const httpDefaults = {
  baseURL: server,
  timeout: 15000,
  withCredentials: true,
};

const toggleLoading = (method, loading, silent) => {
  if(!silent && (method === 'POST' || method === 'post')){
    EventBus.loadingModal(loading);
  }
};

const httpBusiness = axios.create(httpDefaults);
httpBusiness.interceptors.request.use(config => {

  const token = JWTBusiness.getJwtToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  toggleLoading(config.method, true, config.silent);
  return config
});
httpBusiness.interceptors.response.use(response => {
  toggleLoading(response.config.method, false, response.config.silent);
  return response.data;
}, authError);
export default httpBusiness;

const httpStream = axios.create(httpDefaults);
httpStream.interceptors.request.use(config => {
  const token = JWTBusiness.getJwtToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  toggleLoading(config.method, true);
  return config
});
httpStream.interceptors.response.use(response => {
  toggleLoading(response.config.method, false);
  return response;
}, authError);
export {httpStream};


const getBase64Image = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const reader = new FileReader();
  await new Promise((resolve, reject) => {
    reader.onload = resolve;
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  return reader.result;
};

export {getBase64Image}
